import { render, staticRenderFns } from "./SocialMediaPost.vue?vue&type=template&id=2f5b45ca&lang=pug"
import script from "./SocialMediaPost.vue?vue&type=script&lang=ts"
export * from "./SocialMediaPost.vue?vue&type=script&lang=ts"
import style0 from "./SocialMediaPost.vue?vue&type=style&index=0&id=2f5b45ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports